import React from 'react';
import { Box, Typography } from '@mui/material';
import SearchOffOutlinedIcon from '@mui/icons-material/SearchOffOutlined';
import { useSelector } from 'react-redux';
import { handleValidateCodevalue } from '../../Utility/constant';
import './notfound.css';

const NotFoundPage = () => {
    const internationalise = useSelector((state) => state?.internationalise?.currentHashMapData);

    return (
        <Box className="notfound-page-container">
            <Box className="notfound-card-box">
                <Box className="notfound-icon-circle">
                    <SearchOffOutlinedIcon className="notfound-search-icon" />
                </Box>

                <Typography variant="h5" fontWeight={600} color="text.primary" gutterBottom>
                    {handleValidateCodevalue(internationalise, "COMMON_PAGE_NOT_FOUND")}
                </Typography>

                <Typography variant="body2" color="text.secondary" className="notfound-description-text">
                    {handleValidateCodevalue(internationalise, "COMMON_PAGE_NOT_FOUND_DESC")}
                </Typography>
            </Box>
        </Box>
    );
};

export default NotFoundPage;
